import { baseFetchToken } from './BaseSaga'
import SizeActions from '../Redux/SizeRedux'
import { getToken } from '../Services/GetToken'
import { call, put } from 'redux-saga/effects'
import AuthActions from '../Redux/AuthRedux'

export function * getSize (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getSize, token, action.data)
      if (!res.ok) {
        yield put(SizeActions.getSizeFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(SizeActions.getSizeSuccess(DATA_WITH_PAGE))
        } else {
          yield put(SizeActions.getSizeFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(SizeActions.getSizeFailure())
  }
}

export function * getAllSize (api, action) {
  yield baseFetchToken(
    api.getAllSize,
    action.data,
    getToken,
    SizeActions.getAllSizeSuccess,
    SizeActions.getAllSizeFailure
  )
}

export function * createSize (api, action) {
  yield baseFetchToken(
    api.createSize,
    action.data,
    getToken,
    SizeActions.createSizeSuccess,
    SizeActions.createSizeFailure
  )
}

export function * updateSize (api, action) {
  yield baseFetchToken(
    api.updateSize,
    action.data,
    getToken,
    SizeActions.updateSizeSuccess,
    SizeActions.updateSizeFailure
  )
}

export function * deleteSize (api, action) {
  yield baseFetchToken(
    api.deleteSize,
    action.data,
    getToken,
    SizeActions.deleteSizeSuccess,
    SizeActions.deleteSizeFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/SizeSagas.js